<template>
    <div>
        <loading-spinner v-if="this.isLoading"></loading-spinner>
        <div class="single-offer operator-list single-offer-placeholder" v-else-if="!this.isLoading && this.offer != false">
            <div class="operator-item automation-operator-item operator-item-v2">
                <div class="operator-main row mx-0">
                    <div class="d-flex justify-content-center">
                        <div class="operator-column-logo-v2">
                            <div class="logo-wrapper">
                                <a class="operator-item__image_link exit-page-link d-block" rel="nofollow" target="_blank"
                                    :href="this.offer.link | appendfragment(ct, ctaLocation, this.listId || '_', '_', this.rankVersion || '_', listPosition, '_')"
                                    :data-gtm="this.gtmText.replace('LOCATION', 'logo')"
                                    data-kt="oplistclk:a|ctalocation|operator|product|offer|brand_id|brand_product_id|offer_id|site_offer_id"
                                    :data-ctalocation="ctaLocation" :data-operator="this.offer.brand_name"
                                    :data-product="this.offer.brand_product_name"
                                    :data-offer="this.offer.offer_short_description | striptags"
                                    :data-brand_id="this.offer.brand_id"
                                    :data-brand_product_id="this.offer.brand_product_id"
                                    :data-offer_id="this.offer.offer_id" :data-site_offer_id="this.offer.id">
                                    <img class="img-fluid lazyload"
                                        :data-src="this.offer.brand_product_image" :alt="this.offer.brand_product_name"
                                        :title="this.offer.brand_product_name">
                                </a>

                                <div class="operator-established-year-v2">
                                    Established {{ this.offer.established_year }}
                                </div>
                            </div>
                            <div v-if="showReviewLink" style="font-size: 14px; color: #0157ff">
                                <a :href="this.offer.brand_product_review_link"
                                    class="automation-read-review read-review-link"
                                    :data-gtm="'gtm-operator-review ' + this.offer.brand_product_name"
                                    v-if="this.offer.brand_product_review_link">
                                    <span>
                                        Review {{ this.offer.brand_product_name }}
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col px-0">
                        <div class="row mx-0">
                            <div class="operator-column-bonus-v2 col-12 col-md">
                                <div class="offer-description">
                                    <a class="automation-play-now-cta exit-page-link" rel="nofollow" target="_blank"
                                        style="color: initial"
                                        :href="this.offer.link | appendfragment(ct, ctaLocation, this.listId || '_', '_', this.rankVersion || '_', listPosition, '_')"
                                        :data-gtm="this.gtmText.replace('LOCATION', 'cta')"
                                        data-kt="oplistclk:a|ctalocation|operator|product|offer|brand_id|brand_product_id|offer_id|site_offer_id"
                                        :data-ctalocation="ctaLocation" :data-operator="this.offer.brand_name"
                                        :data-product="this.offer.brand_product_name"
                                        :data-offer="this.offer.offer_short_description | striptags"
                                        :data-brand_id="this.offer.brand_id"
                                        :data-brand_product_id="this.offer.brand_product_id"
                                        :data-offer_id="this.offer.offer_id" :data-site_offer_id="this.offer.id">
                                        <label v-if="this.showLabel">{{ this.productType }}</label>
                                        <p class="operator-bonus">
                                            <span v-html="this.offer.offer_short_description"></span>
                                            <span v-if="this.offer.promo_code">
                                                <br>
                                                Promo Code:
                                                <em v-html="this.offer.promo_code"></em>
                                            </span>
                                        </p>
                                    </a>
                                </div>
                            </div>

                            <div class="operator-playnow-column-v2 col-auto col-sm-12 col-lg-auto p-0 px-3 px-lg-0">
                                <a class="automation-play-now-cta operator-item__cta_link exit-page-link" rel="nofollow"
                                    target="_blank"
                                    :href="this.offer.link | appendfragment(ct, ctaLocation, this.listId || '_', '_', this.rankVersion || '_', listPosition, '_')"
                                    :data-gtm="this.gtmText.replace('LOCATION', 'cta')"
                                    data-kt="oplistclk:a|ctalocation|operator|product|offer|brand_id|brand_product_id|offer_id|site_offer_id"
                                    :data-ctalocation="ctaLocation" :data-operator="this.offer.brand_name"
                                    :data-product="this.offer.brand_product_name"
                                    :data-offer="this.offer.offer_short_description | striptags"
                                    :data-brand_id="this.offer.brand_id"
                                    :data-brand_product_id="this.offer.brand_product_id"
                                    :data-offer_id="this.offer.offer_id" :data-site_offer_id="this.offer.id">
                                    <span class="button-blue-v2">{{ this.ctaBtnText }}</span>
                                </a>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="operator-item-link read-terms-link-v2">
                    <div class="terms-and-conditions" 
                        v-if="offer.offer_terms_conditions"
                        v-html="offer.offer_terms_conditions"
                    ></div>
                    
                    <div class="terms-and-conditions" v-else>
                        <span v-if="this.ipCountry == 'CA'">
                            19+. T&C Apply. Play Responsibly
                        </span>

                        <span v-else-if="this.lang == 'FR-CA'">
                            19+. T&C s'appliquent. Jouez de manière responsable
                        </span>

                        <span v-else>
                            <span v-html="getAge()"></span>+, terms apply, 1800-GAMBLER
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <no-state-offer :state="this.region.toUpperCase()" :homepage-link="this.regionHomepageLink" v-else-if="!this.isLoading && !this.showEmailSignUpForm"
            v-cloak></no-state-offer>
    </div>
</template>

<script>
export default {
    name: 'single-offer-export-endpoint',
    props: {
        rankName: {
            type: String,
            required: true,
        },
        defaultGeo: {
            type: String,
            required: true,
        },
        defaultRegion: {
            type: String,
            required: true,
        },
        productType: {
            type: String
        },
        ct: {
            type: String,
            default: 'oplistclk' // Technically getting first offer from a list, also set as this in UK
        },
        ctaLocation: {
            type: String,
            required: true,
        },
        gtm: {
            type: String,
            required: true,
        },
        listPosition: {
            type: Number,
            required: false,
            default: 1,
        },
        showLabel: {
            type: Boolean,
            default: true,
        },
        showReviewLink: {
            type: Boolean,
            default: true,
        },
        showEmailSignUpForm: {
            type: Boolean,
            default: false
        },
        fallbackRankId: {
            type: Number,
            default: 0,
        }
    },
    data() {
        return {
            geo: this.defaultGeo.toLowerCase(),
            region: this.defaultRegion.toLowerCase(),
            offer: false,
            listId: false,
            rankVersion: false,
            ctaBtnText: '',
            gtmText: this.gtm,
            regionHomepageLink: '',
            isLoading: true,
            lang: $('html').attr('lang') ?
                $('html').attr('lang').toUpperCase() : false,
            ipCountry: $('html').attr('data-ipcountry') ?
                $('html').attr('data-ipcountry').toUpperCase() : false,
            regionCode: $('html').attr('data-regioncode') ?
                $('html').attr('data-regioncode').toUpperCase() : false,
        }
    },
    mounted: function () {
        // Check if there is cookie set
        if ($cookies.isKey(('op_list_region_' + this.geo))) {
            this.region = $cookies.get(('op_list_region_' + this.geo)).toLowerCase()
        }

        this.getOffer();
    },
    methods: {
        getOffer() {
            // Washington doesn't have the export endpoint
            if (this.region != 'wa') {
                fetch('/us/json-files/export-' + this.geo + '-' + this.region + '-ranks.json')
                .then((response) => response.json())
                .then((data) => {
                    // Filter rankLists to find the list we want
                    let rankList = data.ranks.data.filter(
                        list => list.metadata.rank_name == this.rankName
                    )[0];

                    // Find fallback list if fallbackRankId is set
                    if (rankList === undefined || rankList.data.length == 0) {
                        if (this.fallbackRankId != 0) {
                            rankList = data.ranks.data.filter(
                                list => list.metadata.rank_id == this.fallbackRankId
                            )[0];
                        }
                    }

                    // Check if list exist and is not empty
                    if (rankList !== undefined && rankList.data.length > 0) {
                        // Get the first site_offer_id in the list
                        let siteOfferId = rankList.data[0];
                        this.listId = rankList.metadata.list_id;
                        this.rankVersion = rankList.metadata.rank_version;

                        // Find the site_offer using the id in the siteOffersList
                        this.offer = data.ranks.metadata.site_offers[siteOfferId]

                        // Data are all split apart in data.ranks.metadata
                        // Format the offer so that all data needed is available
                        this.offer.brand_product_id = data.ranks.metadata.offers[this.offer.offer_id].brand_product_id;
                        this.offer.brand_product_name = data.ranks.metadata.brand_products[this.offer.brand_product_id].name;
                        this.offer.brand_product_image = data.ranks.metadata.brand_products[this.offer.brand_product_id].image;
                        this.offer.brand_product_review_link = data.ranks.metadata.brand_products[this.offer.brand_product_id].link;
                        this.offer.brand_id = data.ranks.metadata.brand_products[this.offer.brand_product_id].brand_id;
                        this.offer.brand_name = data.ranks.metadata.brands[this.offer.brand_id].name;
                        this.offer.established_year = data.ranks.metadata.brands[this.offer.brand_id].established_year;
                        this.offer.offer_short_description = data.ranks.metadata.offers[this.offer.offer_id].description;
                        this.offer.promo_code = data.ranks.metadata.offers[this.offer.offer_id].promo_code;
                        this.offer.offer_terms_conditions = data.ranks.metadata.offers[this.offer.offer_id].terms_and_conditions;

                        this.ctaBtnText = this.productType == "Betting" ?
                            data.translations.gdc_oplist_button_betnow : data.translations.gdc_oplist_button_playnow;
                        this.gtmText = this.gtm.replace('BRANDNAME', this.offer.brand_name);
                        this.gtmText = this.gtmText.replace('BRANDPRODUCTNAME', this.offer.brand_product_name);
                    } else if(this.showEmailSignUpForm) {
                        this.showEmail();
                    }

                    this.setNoGameDemoExitLink();
                    this.ktagRerender();
                    this.isLoading = false;
                });
            } else {
                if(this.showEmailSignUpForm) {
                    this.showEmail();
                }
                this.setNoGameDemoExitLink();
                this.isLoading = false;
            }
        },
        setNoGameDemoExitLink() {
            // This button is from slot_game.blade.php
            // When there is no demo available, we have to set the exit link with the offer we found
            var demoHref = Vue.filter('appendfragment')(this.offer.link, 'cta', 'slot_review_demo', this.listId || '_', '_', this.rankVersion || '_', 1, '_');

            $('#play-demo-btn')
                .attr('href', demoHref)
                .attr('data-operator', this.offer.brand_name)
                .attr('data-product', this.offer.brand_product_name)
                .attr('data-brand_id', this.offer.brand_id)
                .attr('data-brand_product_id', this.offer.brand_product_id);
        },
        getAge() {
            return this.regionCode === 'RI' ? '18' : '21';
        },
        showEmail() {
            // Show Email Sign Up form
            if(document.getElementById('slot-review-email')) {
                document.getElementById('slot-review-email').classList.remove('d-none');
            }

            // Hide all region selectors and offer apart from 1st one
            const elements = document.getElementsByClassName('slot-review-oplist');
            for(let i = 1; i < elements.length; i++) {
                elements[i].classList.add('d-none');
            }

            // Hide offer in slot demo game
            document.getElementById('op-list-game').classList.add('d-none');
        },
        ktagRerender() {
            setTimeout(() => {
                ktag.reRender()
            }, 500);
        }
    },
}
</script>
